module.exports = [{"type":"hash","text":"服務器時間"},{"type":"warning","text":"https://open-api.bingx.com/openApi/spot/v1/server/time"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/basic/04_server_url.json
// module id = w7yn
// module chunks = 3